import { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Checkbox } from './ui/checkbox';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

export default function CancelOrderDialog({
  open,
  order,
  reasonOptions,
  onOpenChange,
  onConfirm,
  saving,
}) {
  const [selected, setSelected] = useState([]);

  useEffect(() => {
    if (open) setSelected([]);
  }, [open, order?.id]);

  const toggle = (label, checked) => {
    setSelected((prev) => {
      if (checked) return prev.includes(label) ? prev : [...prev, label];
      return prev.filter((x) => x !== label);
    });
  };

  const submit = () => {
    if (!selected.length) return;
    onConfirm(selected);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Cancelar pedido #{order?.order_number}</DialogTitle>
          <DialogDescription>
            Indica por qué se cancela (puedes marcar más de una opción). {order?.customer_name}
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {(reasonOptions || []).map((label) => (
            <label
              key={label}
              className="flex items-start gap-3 rounded-md border p-3 cursor-pointer hover:bg-muted/40"
            >
              <Checkbox
                checked={selected.includes(label)}
                onCheckedChange={(v) => toggle(label, Boolean(v))}
              />
              <span className="text-sm leading-snug">{label}</span>
            </label>
          ))}
          {!reasonOptions?.length ? (
            <p className="text-sm text-muted-foreground">
              No hay motivos configurados. Pide al administrador que los agregue en Config tienda.
            </p>
          ) : null}
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>
            Volver
          </Button>
          <Button
            type="button"
            variant="destructive"
            disabled={saving || !selected.length}
            onClick={submit}
          >
            {saving ? 'Cancelando…' : 'Confirmar cancelación'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
